import React from 'react';
import styled from 'styled-components';

import { DepartureCheck } from '@repo/components';
import { useAppSelector } from '@/hooks/useReduxHooks';
import { IGlobalState } from '@/store';
import { useHistory } from 'react-router-dom';
import ReceiptLayout from '@/components/MedicalReceipt/ReceiptLayout';
import { routes } from '@/constant/routes.const';

function DepartureCheckPage() {
  const { nationality } = useAppSelector((state) => state) as IGlobalState;
  const history = useHistory();
  const handleNo = () => {
    history.push(routes.medicalSelectAirport);
    localStorage.setItem('departureCheck', 'no');
  };
  const handleYes = () => {
    history.push(routes.medicalSelectAirport);
    localStorage.setItem('departureCheck', 'yes');
  };

  return (
    <ReceiptLayout>
      <Wrapper>
        <DepartureCheck
          nationality={nationality}
          onYes={handleYes}
          onNo={handleNo}
        />
      </Wrapper>
    </ReceiptLayout>
  );
}

export default DepartureCheckPage;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 16px 0;
`;
